<script>
import { signCloudArchive } from '@domains/pos-operations/api'
import { handleGlobalError } from '@shared/services/errorHandler'
import { formSelect } from 'tb-design_system-web'
import { ref, watchEffect } from 'vue'

export default {
  name: 'appListDocument',

  components: {
    formSelect
  },

  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    typeFile: {
      type: Array,
      default: () => []
    },
    readonlyFiles: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const fileTypes = ref([])
    const typeFileWithOthers = ref([])

    watchEffect(() => {
      typeFileWithOthers.value = [...props.typeFile]
    })

    watchEffect(() => {
      fileTypes.value = props.modelValue.map((file) => file?.docType || null)
    })

    const openUrlInNewWindow = async (url) => {
      try {
        const response = await signCloudArchive({ url })
        window.open(response.data.payload, '_blank')
      } catch (e) {
        handleGlobalError(e)
      }
    }

    const removeFile = (index) => {
      if (index >= 0 && index < props.modelValue.length) {
        const updatedDocuments = [...props.modelValue]
        updatedDocuments.splice(index, 1)
        emit('update:modelValue', updatedDocuments)
      }
    }

    const emitDocumentUpdate = () => {
      const updatedDocuments = props.modelValue.map((file, index) => ({
        ...file,
        docType: fileTypes.value[index] || null
      }))
      emit('update:modelValue', [...updatedDocuments])
    }

    const emitFileTypeChange = (index, fileType) => {
      fileTypes.value[index] = fileType
      emitDocumentUpdate()
    }

    return {
      fileTypes,
      typeFileWithOthers,
      emitFileTypeChange,
      openUrlInNewWindow,
      removeFile
    }
  }
}
</script>

<template>
  <div>
    <div class="row g-2 mt-3 files" v-for="(file, index) in readonlyFiles" :key="index">
      <div class="col-12 pt-3">
        <p @click="openUrlInNewWindow(file.url)" role="button" class="pt-3">
          <i class="bi bi-file-earmark-medical-fill"></i>
          {{ file != null ? file.name || '' : '' }}
        </p>
      </div>
    </div>
    <div class="row g-2 mt-3 files" v-for="(file, index) in modelValue" :key="index">
      <div class="col-5 pt-3">
        <p @click="openUrlInNewWindow(file.url)" role="button" class="pt-3">
          <i class="bi bi-file-earmark-medical-fill"></i>
          {{ file != null ? file.name || '' : '' }}
        </p>
      </div>
      <form-select
        class="col-6 form-input"
        label="Tipo de documento"
        :items="typeFileWithOthers"
        v-model="fileTypes[index]"
        @change="() => emitFileTypeChange(index, fileTypes[index])"
        :id="'fileTypes' + index"
        :name="'fileTypes' + index"
      />
      <div class="col-1 form-input">
        <button @click="removeFile(index)">
          <i class="bi bi-trash-fill"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.files {
  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
